
/* 
 * Use this to log any important console logs.
 * Allows us to easily get rid of console logs for production while keeping important console logs around.
*/

export const logToConsole = (consoleLogMessage) => {
  // console.log(JSON.parse(JSON.stringify(consoleLogMessage))) // deep clones in order to log a snapshot instead of an updating reference
}

export const logError = (errorMessage) => {
  logToConsole(errorMessage)
}

export default { logError, logToConsole }
